import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Paging_CustomType_Api = async (params) => {
    const { data } = await request.post(
        `/CustomType/GetAll_Paging/`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Active_CustomType_Api = async (params) => {
    const { data } = await request.post(
        `/CustomType/GetAll_Active/`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_CustomType_Api = async (params) => {
    const { data } = await request.post(
        `/CustomType/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_CustomType_Api = async (id) => {
    const { data } = await request.get(
        `/CustomType/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_CustomType_Api = async (params) => {
    const { data } = await request.post(
        `/CustomType/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_CustomType_Api = async (id) => {
    const { data } = await request.delete(
        `/CustomType/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
